import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { RouterModule } from '@angular/router';
import { ChatComponent, SplitPaneComponent } from '@components';
import { SplitPaneVerticalComponent, HistoryComponent } from '@components';

interface KpiDeliveryDraft {
  kpiName: string;
  targetValue: string;
  owner: string;
  remediationPlan: string;
}

@Component({
  selector: 'app-kpis',
  templateUrl: './kpis.page.html',
  styleUrls: ['./kpis.page.scss'],
  standalone: true,
  imports: [
    RouterModule,
    FormsModule,
    ChatComponent,
    HistoryComponent,
    SplitPaneComponent,
    SplitPaneVerticalComponent
],
})
export class KpisPage {
  public kpiSuggestions: any[] = [
    { icon: 'bi bi-bullseye', prompt: 'Show KPIs met this month' },
    { icon: 'bi bi-arrow-repeat', prompt: 'KPIs trending down, why?' },
    { icon: 'bi bi-people', prompt: 'Which owners need attention?' },
  ];

  public kpiContext: any = {
    page: 'kpis',
    purpose: 'Track KPIs, owners and trends against targets',
    kpis: [],
    owners: [],
    targets: {},
    timeRange: 'this_month',
    outputs: ['KPIs status', 'Owner attention list', 'Trend explanations']
  };

  public publishingKpi = false;
  public kpiError = '';
  public kpiSuccess = '';
  public hasPublishedKpi = false;
  public kpiDraft: KpiDeliveryDraft = {
    kpiName: '',
    targetValue: '',
    owner: '',
    remediationPlan: '',
  };

  constructor() {}

  public async publishKpiPlan(): Promise<void> {
    this.kpiError = '';
    this.kpiSuccess = '';
    this.hasPublishedKpi = false;

    if (!this.kpiDraft.kpiName.trim()) {
      this.kpiError = 'Enter KPI name before publishing KPI plan.';
      return;
    }
    if (!this.kpiDraft.targetValue.trim()) {
      this.kpiError = 'Enter KPI target value before publishing KPI plan.';
      return;
    }
    if (!this.kpiDraft.owner.trim()) {
      this.kpiError = 'Enter KPI owner before publishing KPI plan.';
      return;
    }

    this.publishingKpi = true;
    try {
      await new Promise((resolve) => setTimeout(resolve, 700));
      this.hasPublishedKpi = true;
      this.kpiSuccess = 'KPI delivery plan published.';
    } finally {
      this.publishingKpi = false;
    }
  }
} 